/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {setWindowTitle} from 'BenchlingUtil';
import DataConnector from 'connect/DataConnector';
import * as RegistryConstants from 'constants/RegistryConstants';
import * as RegistryUtil from 'registry/RegistryUtil';
import * as SampleSchemaActions from 'samples/SampleSchemaActions';
import SampleSchemaStore from 'samples/SampleSchemaStore';
import {ContainerSchema} from 'samples/storables/StorableSchemaConstants';

import ContainerSchemasListing from './ContainerSchemasListing';

class ContainerSchemasPageConnector extends DataConnector<Props, EnhancedProps> {
  override sampleSchemaStore: any;
  override shouldSubscribeToRedux = false;
  override stores = [SampleSchemaStore];

  enhanceProps(): EnhancedProps {
    return {
      containerSchemas: this.sampleSchemaStore().getContainerSchemas(this.props.registryId, {
        includeArchived: true,
      }),
      savingState: this.sampleSchemaStore().getSavingState(),
    };
  }
}

interface Props {
  registryId: string;
  ownerUrlId: string;
}
interface EnhancedProps {
  containerSchemas?: Array<ContainerSchema>;
  savingState: RegistryConstants.SavingState;
}

interface QueryingProps {
  isWritable: boolean;
}
export class ContainerSchemasPage extends React.Component<Props & EnhancedProps & QueryingProps> {
  override componentDidMount(): void {
    SampleSchemaActions.fetchAllContainerSchemas();
  }

  override render(): JSX.Element {
    setWindowTitle('Container Schemas - Registry Settings');
    return (
      // @ts-expect-error ts-migrate(2741) FIXME: Property 'isBeingCreated' is missing in type '{ co... Remove this comment to see the full error message
      <ContainerSchemasListing
        containerSchemas={this.props.containerSchemas}
        isWritable={this.props.isWritable}
        registryId={this.props.registryId}
        ownerUrlId={this.props.ownerUrlId}
        savingState={this.props.savingState}
      />
    );
  }
}

function QueryingContainerSchemasPage(props: Props & EnhancedProps): JSX.Element {
  const isWritable = RegistryUtil.useIsRegistryWritableQuery(props.registryId);
  return <ContainerSchemasPage {...props} isWritable={isWritable} />;
}

export default ContainerSchemasPageConnector.connect(QueryingContainerSchemasPage);
